module.exports = __webpack_public_path__ + "static/media/img_overpaper2.79c48330.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/PC/@1x/img_overpaper2.png
// module id = 959
// module chunks = 0